"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drillToCustomUrlHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var drill_1 = require("../../events/drill");
var resolveDrillToCustomUrl_1 = require("./resolveDrillToCustomUrl");
var getDrillToUrlFilters_1 = require("./getDrillToUrlFilters");
function drillToCustomUrlHandler(ctx, cmd) {
    var _a, resolvedUrl, filtersInfo;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.put(drill_1.drillToCustomUrlRequested(ctx, cmd.payload.drillDefinition, cmd.payload.drillEvent, cmd.correlationId))];
            case 1:
                _b.sent();
                return [4 /*yield*/, effects_1.all([
                        effects_1.call(resolveDrillToCustomUrl_1.resolveDrillToCustomUrl, cmd.payload.drillDefinition, cmd.payload.drillEvent.widgetRef, cmd.payload.drillEvent, ctx, cmd),
                        effects_1.call(getDrillToUrlFilters_1.getDrillToUrlFiltersWithResolvedValues, ctx, cmd.payload.drillEvent.widgetRef),
                    ])];
            case 2:
                _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), resolvedUrl = _a[0], filtersInfo = _a[1];
                return [2 /*return*/, drill_1.drillToCustomUrlResolved(ctx, resolvedUrl, cmd.payload.drillDefinition, cmd.payload.drillEvent, filtersInfo, cmd.correlationId)];
        }
    });
}
exports.drillToCustomUrlHandler = drillToCustomUrlHandler;
//# sourceMappingURL=drillToCustomUrlHandler.js.map